import { createFileRoute } from '@tanstack/react-router';
import { DIFFICULTY_MODES, type DifficultyMode } from '@lk/shared';
import { ModeSelectScreen } from '../features/modes/ModeSelectScreen';
import { RequireAuth } from '../features/auth/RequireAuth';

export interface ModesSearch {
  mode?: DifficultyMode;
}

export const Route = createFileRoute('/modes')({
  validateSearch: (search: Record<string, unknown>): ModesSearch => {
    const raw = search['mode'];
    return DIFFICULTY_MODES.includes(raw as DifficultyMode)
      ? { mode: raw as DifficultyMode }
      : {};
  },
  component: ModesRoute,
});

function ModesRoute(): React.JSX.Element {
  const { mode } = Route.useSearch();
  return (
    <RequireAuth role="child">
      {(me) => <ModeSelectScreen me={me} {...(mode ? { initialMode: mode } : {})} />}
    </RequireAuth>
  );
}
